module.exports = __webpack_public_path__ + "media/images/Estados-financieros-6eff140fc7809f8189e0595cf069976c.png";